<section class="flex flex-col gap-3 xl:gap-6">
  <app-segment
    [(value)]="segment"
    (valueChange)="segmentChange()"
    [options]="segments()"
  />
  <router-outlet />
</section>
